"use client";

import { c as _c } from "react/compiler-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { Label } from "@/components/ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
const MARKETING_OPTIONS = [{
  value: "not_set",
  label: "Not Set"
}, {
  value: "true",
  label: "Opted In"
}, {
  value: "false",
  label: "Opted Out"
}] as const;
function toSelectValue(value: boolean | null | undefined): string {
  if (value === true) return "true";
  if (value === false) return "false";
  return "not_set";
}
function fromSelectValue(value: string): boolean | null {
  if (value === "true") return true;
  if (value === "false") return false;
  return null;
}
export default function MarketingField(t0) {
  const $ = _c(20);
  const {
    required: t1
  } = t0;
  const required = t1 === undefined ? false : t1;
  const {
    control,
    formState: t2
  } = useFormContext();
  const {
    errors
  } = t2;
  const smsMarketingError = errors.optedInToSmsMarketing?.message;
  const emailMarketingError = errors.optedInToEmailMarketing?.message;
  let t3;
  if ($[0] !== required) {
    t3 = <Label mandatory={required}>Marketing Preferences</Label>;
    $[0] = required;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-body text-foreground-secondary">SMS Marketing</span>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== smsMarketingError) {
    t5 = t6 => {
      const {
        field
      } = t6;
      return <Select value={toSelectValue(field.value)} onValueChange={val => field.onChange(fromSelectValue(val))}><SelectTrigger hasError={!!smsMarketingError} errorMessage={typeof smsMarketingError === "string" ? smsMarketingError : undefined}><SelectValue /></SelectTrigger><SelectContent>{MARKETING_OPTIONS.map(_temp)}</SelectContent></Select>;
    };
    $[3] = smsMarketingError;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== control || $[6] !== t5) {
    t6 = <div className="space-y-1">{t4}<Controller name="optedInToSmsMarketing" control={control} render={t5} /></div>;
    $[5] = control;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-body text-foreground-secondary">Email Marketing</span>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== emailMarketingError) {
    t8 = t9 => {
      const {
        field: field_0
      } = t9;
      return <Select value={toSelectValue(field_0.value)} onValueChange={val_0 => field_0.onChange(fromSelectValue(val_0))}><SelectTrigger hasError={!!emailMarketingError} errorMessage={typeof emailMarketingError === "string" ? emailMarketingError : undefined}><SelectValue /></SelectTrigger><SelectContent>{MARKETING_OPTIONS.map(_temp2)}</SelectContent></Select>;
    };
    $[9] = emailMarketingError;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== control || $[12] !== t8) {
    t9 = <div className="space-y-1">{t7}<Controller name="optedInToEmailMarketing" control={control} render={t8} /></div>;
    $[11] = control;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t6 || $[15] !== t9) {
    t10 = <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">{t6}{t9}</div>;
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t3) {
    t11 = <div className="space-y-2">{t3}{t10}</div>;
    $[17] = t10;
    $[18] = t3;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}
function _temp2(option_0) {
  return <SelectItem key={option_0.value} value={option_0.value}>{option_0.label}</SelectItem>;
}
function _temp(option) {
  return <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>;
}
export { MARKETING_OPTIONS, toSelectValue, fromSelectValue };